import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Note } from 'src/app/classes/models';
import { NoteService } from 'src/app/services/note.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-note-ticket-display-modal',
  templateUrl: './note-ticket-display-modal.component.html',
  styleUrl: './note-ticket-display-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NoteTicketDisplayModalComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);
  constructor(
    private ActiveModal: NgbActiveModal,
    private ToastService: ToastService,
    private NoteService: NoteService,
    private UtilityService: UtilityService
  ) {}

  @Input() NoteId!: number;
  Note!: Note;

  close() {
    return this.ActiveModal.dismiss();
  }

  ngOnInit(): void {
    if (!this.NoteId) {
      throw this.ToastService.addErrorToast('Error', 'Missing note id.', {
        returnError: true
      });
    }

    this.NoteService.getNote(
      this.UtilityService.stringifyObjectsInQueryObject({
        attributes: ['id', 'ticketId'],
        id: this.NoteId,
        ZendeskTicket: {
          attributes: ['id']
        }
      })
    ).subscribe({
      next: (Note) => {
        this.Note = Note;
        this._cdr.markForCheck();
      }
    });
  }
}
